import { Box, Text } from '@domain-group/suit-theme'
import { snakeToTitleCase } from '@domain-group/javascript-utils'

import ToggleListItem from '@components/ToggleListItem'

interface PermissionGroupProps {
  allEnabled?: boolean,
  callbacks: {
    updatePermissionGroup: (key: string) => void,
  },
  customPermissionGroup: { [key: string]: any },
  disabled?: boolean,
  lastGroup: boolean,
  permissionGroup: { [key: string]: any },
  permissionGroupKey: string,
}

const PermissionGroup = (props: PermissionGroupProps) => {
  const {
    allEnabled,
    callbacks: { updatePermissionGroup },
    customPermissionGroup,
    disabled,
    lastGroup,
    permissionGroup = {},
    permissionGroupKey,
  } = props

  const permissionKeys = Object.keys(permissionGroup)

  const title = permissionGroupKey === 'photos_and_plans' ? 'Photos & Plans' : snakeToTitleCase(permissionGroupKey)

  return (
    <Box
      borderBottom={lastGroup ? 'none' : '1px dashed'}
      borderColor="lineColor"
      flexDirection="column"
      paddingY="medium"
    >
      <Text color="bodyFontLightColor" marginY="medium" fontSize="xsmall">
        {title}
      </Text>

      {permissionKeys.map((key) => {
        const customEnabled = customPermissionGroup[key]
        const enabled = allEnabled || (customEnabled === undefined ? permissionGroup[key] : customEnabled)

        return (
          <ToggleListItem
            key={key}
            boxProps={{
              marginBottom: 'medium',
              opacity: disabled ? 0.5 : 1,
            }}
            onClick={() => updatePermissionGroup(key)}
            toggleValue={enabled}
          >
            <Text fontSize="small" maxWidth="fit-content" variant="twoLineEllipsis" paddingRight="large">
              {snakeToTitleCase(key)}
            </Text>
          </ToggleListItem>
        )
      })}
    </Box>
  )
}

export default PermissionGroup
